module.exports = __webpack_public_path__ + "static/media/logo-white.5b984c9d.svg";